export const ICONS_BASE_URL = 'https://unpkg.com/lucide-static/icons';

export const getLucideIconUrl = (icon) => `${ICONS_BASE_URL}/${icon}.svg`;

export const HOMEPAGE_HOW_IT_WORKS = [
  {
    title: 'Share moments',
    description: 'Send your photos and clips. We organize everything for your story.',
    icon: 'upload',
  },
  {
    title: 'Craft premiere',
    description: 'We shape your private Veeflix experience with cinematic flow.',
    icon: 'wand-2',
  },
  {
    title: 'Private link',
    description: 'Invite-only access with account-linked viewing control.',
    icon: 'mail',
  },
];

export const HOMEPAGE_BENEFITS = [
  {
    title: 'Done-for-you',
    description: 'No editing dashboards. No setup complexity.',
    icon: 'wand-2',
  },
  {
    title: 'Private & secure',
    description: 'Invite-based login and profile-level access checks.',
    icon: 'lock',
  },
  {
    title: 'Hosted for you',
    description: 'Reliable streaming delivery without heavy local files.',
    icon: 'cloud',
  },
  {
    title: 'Streaming style',
    description: 'Immersive rows, previews, and full-screen playback.',
    icon: 'tv',
  },
  {
    title: 'Play-first UX',
    description: 'Built to feel like a private screening, not a folder.',
    icon: 'play',
  },
];

export const HOMEPAGE_GENRES = [
  { label: 'Birthdays', icon: 'cake' },
  { label: 'Anniversaries', icon: 'flower' },
  { label: 'First Trips', icon: 'plane' },
  { label: 'Personal Journals', icon: 'book' },
  { label: 'Farewells', icon: 'handshake' },
  { label: 'Baby’s First Year', icon: 'baby' },
  { label: 'Kids Growing Up', icon: 'users' },
  { label: 'Festive Celebrations', icon: 'sparkles' },
  { label: 'Year-in-Review', icon: 'video' },
  { label: 'Family Reunion', icon: 'home' },
  { label: 'Weddings', icon: 'ring' },
  { label: 'Gifts', icon: 'gift' },
  { label: 'Graduation', icon: 'graduation-cap' },
  { label: 'Unforgettable Moments', icon: 'star' },
  { label: 'Christmas', icon: 'tree-pine' },
  { label: 'Eid', icon: 'moon' },
];

export const HOMEPAGE_FAQ = [
  {
    q: 'Is Veeflix public?',
    a: 'No. Veeflix is invite-only. Access is account-linked and controlled per experience.',
  },
  {
    q: 'Can people sign up directly?',
    a: 'No public signup is available. Accounts are created only through private invite links.',
  },
  {
    q: 'Do I need to edit videos myself?',
    a: 'No. Veeflix is done-for-you. You share memories, and we craft the streaming experience.',
  },
  {
    q: 'Can one experience be shared with multiple people?',
    a: 'Yes. We can grant access to multiple accounts under the same profile group.',
  },
];
